<template lang="pug">
  div
    .card.border-secondary
      .card-header.bg-dark.text-white
        .float-right
          router-link.btn.btn-outline-light.btn-sm( :to="{ name: 'user_new' }" )( v-if="$session.$isManagement()" )
            i.fa.fa-plus.mr-1
            | New User
        h4.mb-0
          i.fa.fa-user.mr-2
          | Users
      .card-body

        .row.mb-2
          .col-md-1
            select#per-page.form-control( v-model.number="perPage" )
              option( value="1" ) 1
              option( value="10" ) 10
              option( value="25" ) 25
              option( value="50" ) 50
              option( value="100" ) 100

          .col-md-5
            .d-flex.h-100.text-muted( v-if="loaded" )
              .align-self-center.pb-2 {{ paginateStatus }}

          .col-md-6
            .float-right( v-if="loaded" )
              pagination( :currentPage="page"
                          :total="count"
                          :page-size="perPage"
                          :callback="pageChanged"
                          :options="paginationOptions" )

        table.table.table-sm.table-bordered.table-hover.table-stripped.table-sortable.w-100.d-block.d-md-table.table-responsive
          thead.bg-secondary.text-white
            tr
              th( @click="changeSort( 'name' )" )
                | User's Full Name
                i.fa.fas.ml-2( :class="sortClass( 'name' )" )
              th( @click="changeSort( 'username' )" )
                | Username
                i.fa.fas.ml-2( :class="sortClass( 'username' )" )
              th( @click="changeSort( 'email' )" )
                | User Email
                i.fa.fas.ml-2( :class="sortClass( 'email' )" )
              th( @click="changeSort( 'role' )" )
                | Role
                i.fa.fas.ml-2( :class="sortClass( 'role' )" )
              th.action( width="10%" )
            tr
              th
                .input-group
                  input.form-control.form-control-sm( :value="filters.name"
                                                      @input="debounceName"
                                                      placeholder="Filter Full Name" )
                  .input-group-append
                    button.btn.bg-white.btn-sm( @click="filters.name = ''" )
                      i.fas.fa-times
              th
                .input-group
                  input.form-control.form-control-sm( :value="filters.username"
                                                      @input="debounceUsername"
                                                      placeholder="Filter Username" )
                  .input-group-append
                    button.btn.bg-white.btn-sm( @click="filters.username = ''" )
                      i.fas.fa-times
              th
                .input-group
                  input.form-control.form-control-sm( :value="filters.email"
                                                      @input="debounceEmail"
                                                      placeholder="Filter Email" )
                  .input-group-append
                    button.btn.bg-white.btn-sm( @click="filters.email = ''" )
                      i.fas.fa-times
              th
                .input-group
                  input.form-control.form-control-sm( :value="filters.role"
                                                      @input="debounceRole"
                                                      placeholder="Filter Role" )
                  .input-group-append
                    button.btn.bg-white.btn-sm( @click="filters.role = ''" )
                      i.fas.fa-times
              th.action
          tbody
            tr.pointer( v-for="row in data" :key="row.id" @click="goto( row )" v-if="loaded" )
              td {{ row.name }}
              td {{ row.username }}
              td {{ row.email }}
              td {{ row.role }}
              td
                ul.list-unstyled.mb-0
                  li
                    router-link( :to="{ name: 'user_edit', params: { id: row.id } }" )
                      i.fa.fa-pencil-alt.mr-2( v-tooltip="'Edit User'" )
                    router-link( :to="{ name: 'user_delete', params: { id: row.id } }"
                         @click.native="$event.stopImmediatePropagation()")
                      i.fa.fa-trash-alt.mr-2( v-tooltip="'Delete User'" )

            tr( v-if="data.length === 0 && loaded" )
              td( colspan="4" )
                small.text-muted
                  | (No matching users)

            tr( v-if="loading" )
              td( colspan="4" )
                i.fa.fa-spinner.fa-spin.fa-2x.mt-2( v-if="loading" )

        .row
          .col-md-6
            .d-flex.h-100.text-muted( v-if="loaded" )
              .align-self-center.pb-2 {{ paginateStatus }}
          .col-md-6
            .float-right( v-if="loaded" )
              pagination( :currentPage="page"
                          :total="count"
                          :page-size="perPage"
                          :callback="pageChanged"
                          :options="paginationOptions" )

</template>

<script>
  import tableUtils from '../../mixins/table_utils'
  import pagination from '../../mixins/paginate'

  export default {
    name: 'UsersIndex',

    mixins: [ tableUtils ],

    components: { pagination },

    data() {
      return {
        data:   [],
        loaded: false,
        loading: false,

        perPage: 10,
        count:   0,
        page:    1,

        filters: {
          name:  '',
          username:  '',
          email: '',
          role:  '',
        },

        paginationOptions: {
          offset:             4,
          alwaysShowPrevNext: true
        }
      }
    },

    computed: {
      paginateStatus() {
        if ( _.every( _.values( this.filters ), _.isEmpty ) ) {
          let start = ( this.page - 1 ) * this.perPage + 1
          let end = start + this.perPage - 1
          if ( end < this.perPage ) {
            end = this.perPage
          }
          else if ( end > this.count ) {
            end = this.count
          }
          return 'Showing ' + start + ' to ' + end + ' of ' + this.count + ' Users'
        }
        else {
          return 'Showing ' + this.data.length + ' of ' + this.count + ' Users'
        }
      }
    },

    watch: {
      perPage: 'fetchData',
      filters: { handler: function() { this.fetchData() }, deep: true }
    },

    mounted() {
      this.perPage = parseInt( localStorage.usersIndexPerPage ) || 10
      this.sortColumn = 'name'

      this.$watch( () => { return this.reverse }, () => this.fetchData() )
      this.$watch( () => { return this.sortColumn }, () => this.fetchData() )

      this.fetchData()
    },

    methods: {
      fetchData() {
        localStorage.customerIndexPerPage = this.perPage
        this.loaded = false
        this.loading = true

        this.$http.secured.get( 'users', { params: {
            page:           this.page,
            per_page:       this.perPage,
            sort_column:    this.sortColumn,
            sort_direction: this.reverse ? 'desc' : 'asc',
            filters:        this.filters
          }})
          .then( ( response ) => {
            this.data = response.data.users
            this.count = response.data.count
            this.loaded = true
            this.loading = false
          })
      },

      goto( model ) {
        this.$router.push( { name: 'user_edit', params: { id: model.id } } )
      },

      pageChanged( page ) {
        this.page = page
        this.fetchData()
      },

      debounceName: _.debounce( function( e ) { this.filters.name = e.target.value }, 500 ),
      debounceUsername: _.debounce( function( e ) { this.filters.username = e.target.value }, 500 ),
      debounceEmail: _.debounce( function( e ) { this.filters.email = e.target.value }, 500 ),
      debounceRole: _.debounce( function( e ) { this.filters.role = e.target.value }, 500 ),
    }
  }
</script>

<style scoped>
</style>
